export default __webpack_public_path__ + "static/2.5.1/media/diagmaticLogoBlack.95db2f3f.svg";